!function () {
  "use strict";

  function e(e) {
    return !("number" != typeof e || e !== e || e === 1 / 0 || e === -(1 / 0));
  }

  function t(e) {
    return h.test(e) || s.test(e) ? e + "th" : u.test(e) ? e.replace(u, "ieth") : a.test(e) ? e.replace(a, n) : e;
  }

  function n(e, t) {
    return d[t];
  }

  function o(t) {
    var n = parseInt(t, 10);
    if (!e(n)) throw new TypeError("Not a finite number: " + t + " (" + typeof t + ")");
    var o = String(n),
        r = n % 100,
        i = r >= 11 && 13 >= r,
        f = o.charAt(o.length - 1);
    return o + (i ? "th" : "1" === f ? "st" : "2" === f ? "nd" : "3" === f ? "rd" : "th");
  }

  function r(n, o) {
    var r,
        f = parseInt(n, 10);
    if (!e(f)) throw new TypeError("Not a finite number: " + n + " (" + typeof n + ")");
    return r = i(f), o ? t(r) : r;
  }

  function i(e) {
    var t,
        n,
        o = arguments[1];
    return 0 === e ? o ? o.join(" ").replace(/,$/, "") : "zero" : (o || (o = []), 0 > e && (o.push("minus"), e = Math.abs(e)), 20 > e ? (t = 0, n = x[e]) : p > e ? (t = e % v, n = M[Math.floor(e / v)], t && (n += "-" + x[t], t = 0)) : y > e ? (t = e % p, n = i(Math.floor(e / p)) + " hundred") : c > e ? (t = e % y, n = i(Math.floor(e / y)) + " thousand,") : b > e ? (t = e % c, n = i(Math.floor(e / c)) + " million,") : g > e ? (t = e % b, n = i(Math.floor(e / b)) + " billion,") : m > e ? (t = e % g, n = i(Math.floor(e / g)) + " trillion,") : w >= e && (t = e % m, n = i(Math.floor(e / m)) + " quadrillion,"), o.push(n), i(t, o));
  }

  function f(e) {
    var n = r(e);
    return t(n);
  }

  var l = "object" == typeof self && self.self === self && self || "object" == typeof global && global.global === global && global || this,
      h = /(hundred|thousand|(m|b|tr|quadr)illion)$/,
      s = /teen$/,
      u = /y$/,
      a = /(zero|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)$/,
      d = {
    zero: "zeroth",
    one: "first",
    two: "second",
    three: "third",
    four: "fourth",
    five: "fifth",
    six: "sixth",
    seven: "seventh",
    eight: "eighth",
    nine: "ninth",
    ten: "tenth",
    eleven: "eleventh",
    twelve: "twelfth"
  },
      v = 10,
      p = 100,
      y = 1e3,
      c = 1e6,
      b = 1e9,
      g = 1e12,
      m = 1e15,
      w = 9007199254740992,
      x = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"],
      M = ["zero", "ten", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"],
      z = {
    toOrdinal: o,
    toWords: r,
    toWordsOrdinal: f
  };
  "undefined" != typeof exports ? ("undefined" != typeof module && module.exports && (exports = module.exports = z), exports.numberToWords = z) : l.numberToWords = z;
}();